import React, { FC } from 'react'

import { IconChartLineProps } from './IconChartLine.types'
import * as Styled from './styles/IconChartLine.style'

import { nonThemeableRules } from '../../ruleSet'

const IconChartLine: FC<IconChartLineProps> = ({
  size = nonThemeableRules.defaultSize as number as IconChartLineProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconChartLineProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M156 152H4a4 4 0 0 0 0 8h152a4 4 0 0 0 0-8zM24 108a4 4 0 0 0 2.86-1.2l10.06-10.28L47 106.8a4 4 0 0 0 2.83 1.2 4.17 4.17 0 0 0 2.85-1.17L93.9 65.74l21.95 23.39a4 4 0 0 0 5.78.06l17.23-17.6a4 4 0 0 0-5.72-5.6l-14.31 14.63-21.91-23.36A4 4 0 0 0 94.07 56a4 4 0 0 0-2.89 1.17l-41.3 41.15L39.78 88a4 4 0 0 0-5.72 0l-12.92 13.2A4 4 0 0 0 24 108z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconChartLine
